<section class="error-container">
  <vdw-header [title]="'GENERAL.ERRORS.SOMETHING_WRONG' | bmsTranslate" svgIcon="error-full-52px" [canShowClose]="true"></vdw-header>
  <article class="dialog-content">
    <vdw-message-container [showTitle]="true" [title]="'PRODUCTION_ORDER.WEAVE_PLAN.CONFIRMATION.WARNINGS.SUBTITLE' | bmsTranslate" [messages]="getMessages()"> </vdw-message-container>
  </article>
</section>
